/* esm.sh - react-router@8.4.0/dist/production/lib/dom/ssr/routeModules */
async function t(o,e){if(o.id in e)return e[o.id];try{let r=await import(o.module);return e[o.id]=r,r}catch(r){if(console.error(`Error loading route module \`${o.module}\`, reloading page...`),console.error(r),window.__reactRouterContext&&window.__reactRouterContext.isSpaMode&&import.meta.hot)throw r;return window.location.reload(),new Promise(()=>{})}}export{t as loadRouteModule};
/*! Bundled license information:

react-router/dist/production/lib/dom/ssr/routeModules.js:
  (**
   * react-router v8.4.0
   *
   * Copyright (c) Remix Software Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE.md file in the root directory of this source tree.
   *
   * @license MIT
   *)
*/
//# sourceMappingURL=routeModules.mjs.map